<template>
    <el-dialog title="文章审核" :visible.sync="_auditFormVisible" width="500px">
        <el-form ref="form" :model="form"  :rules="rules" size="mini">
            <el-form-item label="审核结果" prop="status">
                <el-radio-group v-model="form.status">
                    <el-radio :label="0">通过</el-radio>
                    <!-- <el-radio :label="2">驳回</el-radio> -->
                </el-radio-group>
            </el-form-item>
          <!--  <el-form-item label="审核描述">
                <el-input type="textarea" v-model="form.examineDescribe"></el-input>
            </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="_auditFormVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="onSubmit">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: "",
    props: {
        auditFormVisible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            form: {},
            centerDialogVisible: true,
            rules: {
                status: [
                    {
                        required: true,
                        message: "请选择审核结果",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    computed: {
        _auditFormVisible: {
            get() {
                return this.auditFormVisible;
            },
            set(val) {
                this.$emit("update:auditFormVisible", val);
            },
        },
    },
    methods: {
        onSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$emit("submitForm", this.form);
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
